import { BannerOut } from '../../store/api';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

type Props = {
    readonly banner: BannerOut;
};

export const BannerItem: FC<Props> = ({ banner }) => {
    if (banner.targetUrl) {
        return (
            <Link to={banner.targetUrl}>
                <img src={banner.imageUrl} />
            </Link>
        );
    }

    return <img src={banner.imageUrl} />;
};
